// extracted by mini-css-extract-plugin
module.exports = {"ReallocateShiftCTA":"appointments__ReallocateShiftCTA__ReallocateShiftCTA","ReallocateShiftCTAError":"appointments__ReallocateShiftCTA__ReallocateShiftCTAError"};